import styled from 'styled-components';

export const StyledContainer = styled.div`
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 16px;
`;

export const StyledContainerFluid = styled.div`
  background-color: ${({ theme }) => theme.palette.surface.secondary};
  width: 100%;
`;
